import React from "react";
import Chart from "react-apexcharts";

const Columnchart = ({ data = [], horizontal, title }) => {
  const options = {
    chart: {
      type: "bar",
      height: 350,

      toolbar: {
        show: true,
        offsetX: -57,
        offsetY: -18,

        tools: {
          download:
            '<button style="background:#1677ff;color:white;border:none;border-radius:6px;padding:8px 14px;font-size:14px;font-weight:600;cursor:pointer;">Download</button>',
        },
      },
    },

    plotOptions: {
      bar: {
        horizontal: horizontal,
        columnWidth: "50%",
      },
    },

    dataLabels: {
      enabled: true,
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    xaxis: {
      categories: [title],
    },

    yaxis: {
      title: {
        text: "",
      },
    },

    fill: {
      opacity: 1,
    },

    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
  };

  if (data?.length) {
    return (
      <Chart
        options={options}
        series={data}
        type="bar"
        width={"100%"}
        height={400}
      />
    );
  }

  return null;
};

export default Columnchart;